import React from 'react';
import BaseCell from './BaseCell';

const PairsCell = ({
  pairs, title, ...props
}) => (
  <BaseCell {...props}>
    <div className='pairs-cell'>
      {title && <div className='pairs-title'>{title}</div>}
      {pairs.map(({ key, value }) => (
        <div className='pair' key={key}>
          {key && (
            <span className='pair-key'>
              {`${key} `}
            </span>
          )}
          {value ?? '-'}
        </div>
      ))}
    </div>
  </BaseCell>
);

export default PairsCell;
